import ContactForm from "../Form/ContactForm";
import "../../styles/ContactUs.css";
import Customer from "../../assets/customer_bg.png";
import { Helmet } from "react-helmet-async";
export default function ContactSection() {
  return (
    <>
      <Helmet>
        <title>
          Contact Ponvel Exim – Global Exporters of Food, FMCG & Coir Products
        </title>
        <meta
          name="description"
          content="Get in touch with Ponvel Exim, India's trusted global exporter of food, FMCG, coir, and textile products. Reach out for export partnerships, trade inquiries, or product information."
        />
        <meta
          name="keywords"
          content="Ponvel Exim contact,export company India,global exporters,international trade contact,Indian export business"
        />
        <link rel="canonical" href="https://ponvelexim.com/contact" />

        {/* Open Graph (Facebook) */}
        <meta
          property="og:title"
          content="Contact Ponvel Exim – Trusted Indian Exporters Worldwide"
        />
        <meta
          property="og:description"
          content="Contact Ponvel Exim for global export inquiries on food, FMCG, coir, and textile products. Delivering excellence from India to the world."
        />
        <meta
          property="og:image"
          content="https://ponvelexim.com/logo192.png"
        />
        <meta property="og:url" content="https://ponvelexim.com/contact" />
        <meta property="og:type" content="website" />

        {/* Twitter Meta */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Contact Ponvel Exim – Export House of India"
        />
        <meta
          name="twitter:description"
          content="Reach out to Ponvel Exim for reliable export services in food, FMCG, coir, and home textiles. Connect with our global trade team."
        />
        <meta
          name="twitter:image"
          content="https://ponvelexim.com/logo192.png"
        />
      </Helmet>

      <div className="contact-background">
        <div className="customer-section">
          <h1>Feel free to get in touch</h1>
          <p className="contact-line">
            we can deliver great results for your online business <br></br>
            without additional costs or commitments.
          </p>
          <div className="contact-section">
            <div className="contactus-form">
              <ContactForm />
            </div>
            <div className="contact-info">
              <h3>DON'T HESITATE TO CONTACT US</h3>

              <div className="info-box">
                <span className="label office">OFFICE</span>
                <p>
                  1/2, Ramasamy Gounder Layout, 60 Feet Road,
                  <br />
                  Perichipalayam South, Tirupur - 641 604.
                </p>
              </div>

              <div className="info-box">
                <span className="label hours">WORK HOURS</span>
                <p>Everyday : Monday - Saturday</p>
              </div>

              <div className="info-box">
                <span className="label phone">PHONE</span>
                <p>+91 9363088257</p>
              </div>

              <div className="info-box">
                <span className="label email">E-MAIL</span>
                <p>support@ponvelexim.com</p>
              </div>
            </div>
          </div>
        </div>
        <img
          src={Customer}
          className="customer-image"
          alt="customer-image-logo"></img>
      </div>
    </>
  );
}
